// Right-sized images from our own file server. /api/files/<path>?w=N returns a WebP no wider than N
// (backend snaps N to 320/480/640/960/1280 and caches it). Any other URL is returned unchanged.
const isOurFile = (url) => typeof url === 'string' && url.includes('/api/files/') && !url.includes('?');

export function sized(url, w) {
  return isOurFile(url) ? `${url}?w=${w}` : url;
}

// srcSet for responsive <img>; undefined for URLs we can't resize (the browser then uses src).
export function sizedSrcSet(url, widths = [480, 960]) {
  return isOurFile(url) ? widths.map((w) => `${url}?w=${w} ${w}w`).join(', ') : undefined;
}
